export default __webpack_public_path__ + "static/media/LearnMoreModal.9f141c4a.jpg";